import React from "react";
export default React.memo(function Select({ children, ...rest }) {
  return (
    <select
      {...rest}
      className="w-64 h-10 px-3 border border-slate-300 rounded-lg bg-white outline-none focus:ring-2 focus:ring-brand-200"
    >
      {children}
    </select>
  );
});
